import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { TagItem } from '@atlassian/jira-list-with-popup/src/ui/tag-item/index.tsx';

type ColorProps = {
	color?: string | null;
	isColored?: boolean;
};

export type Props = ColorProps &
	(
		| {
				text?: string | null;
				noValueText: string;
		  }
		| {
				text: string;
				noValueText?: never;
		  }
	);

export const TagGroupHeaderContent = ({ text, noValueText, ...colorProps }: Props) => {
	return text ? (
		<TagItem name={text} {...colorProps} isHoverPopoverEnabled />
	) : (
		<Text>{noValueText}</Text>
	);
};
